require('./bootstrap');

(function($) {
    var footnotes = [];
    var articleWrapper = $('.article-list');
    var tooltip = function (txt, note) {
        txt = `<span data-toggle="tooltip" class="txt-footnote" data-html="true" title="${entities.escape(txt)}">${note}</span>`;
        return txt;
    }
    var init = function () {
        var article = articleWrapper.html();
        article = article.replace(/<\/?span[^>]*>/g,"");
        $('.footnotes').children().each(function (k, e) {
            var noteTxt = $(e).html();
            var i = $($(e).find("b")).html();
            if( i === undefined || i.length == 0) {
                i = $($(e).find("strong")).html();
            }
            if(!footnotes.includes(i) && i !== undefined && i.length > 0) {
                i = i.replace(/\s/g, '');
                article = article.replaceAll(i, tooltip(noteTxt, i));
                footnotes.push(i);
            }
        });
        articleWrapper.html(article);
    }

    $('document').ready(function() {
        $('body').on('click', '.btn-note', function(e) {
            e.preventDefault();
            var _this = this;
            var t = $(this).attr('data-target');
            $(_this).toggleClass('active');
            $(t).slideToggle("slow");
        });
        if(articleWrapper.length > 0) {
            init();
        }
    });

}) (jQuery);
